
export default function stickyHeader(scrollOffset) {
    const nav = document.querySelector('.main-nav-holder');

    handleScroll();
    window.addEventListener('scroll', handleScroll);

    function handleScroll () {
        if ( window.scrollY > scrollOffset ) {
            nav.classList.add('main-nav-holder--scrolled');
        } else {
            nav.classList.remove('main-nav-holder--scrolled');
        }
    }
}
